import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import linkedinIcon from "../assets/img/linkedin.svg";
import githubIcon from "../assets/img/github.svg";
import myPhoto from "../assets/img/me.png";
import "animate.css";
import TrackVisibility from "react-on-screen";

export const Banner = () => {
  const [loopNumber, setLoopNumber] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const whoIam = [
    "Data Scientist",
    "Data Analyst",
    "Research Scientist",
    "Natural Language Processing",
    "Computer Vision",
    "Time Series Analyst/Forecaster",
    "ForestMap",
    "Data Science Manager/Lead",
    "AI/ML Architect"
  ];
  const [text, setText] = useState("");
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const period = 500;

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => {
      clearInterval(ticker);
    };
  }, [text, isDeleting]);

  const tick = () => {
    let i = loopNumber % whoIam.length;
    let fullText = whoIam[i];
    let updatedText = isDeleting
      ? fullText.substring(0, text.length - 1)
      : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta((prevDelta) => prevDelta / 1.5);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setDelta(period);
    } else if (isDeleting && updatedText === "") {
      setIsDeleting(false);
      setLoopNumber(loopNumber + 1);
      setDelta(200); 
    }
  };

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="align-itens-center">
          <Col xs={12} md={6} xl={5}>
            <div className="myphoto">
              <img src={myPhoto} alt="Header Img" />
            </div>
          </Col>
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <h1>
                    {`Onkar Dass`}
                    <br></br>
                    <div id="whiIamType">
                      <span className="whoIam-word"> {text} </span>
                      <span className="blinking-border"></span>
                    </div>
                  </h1>
                  <p>
                    As a Data Scientist, I am driven by a deep curiosity for
                    data and a strong commitment to continuous learning and
                    improvement. I enjoy collaborating in multidisciplinary
                    teams to tackle complex problems and develop evidence-based
                    solutions. Outside of the professional sphere, I am
                    passionate about exploring new analytical techniques,
                    staying up to date with advancements in machine learning,
                    and discovering how data can transform our world
                  </p>
                  <span className="navbar-text">
                    <div className="social-icon">
                      <a
                        href="https://www.linkedin.com/in/onkardasskaur"
                        target="_blank"
                      >
                        <img src={linkedinIcon} alt=""></img>
                      </a>
                      <a href="https://github.com/onkardaka" target="_blank">
                        <img src={githubIcon} alt=""></img>
                      </a>
                    </div>
                  </span>
                  <div className="available-work">
                    <span className="green-light"></span>
                      Available to Work
                  </div>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};